import axios from 'axios'
import qs from 'qs'
import {Message, MessageBox} from 'element-ui'
import util from '@/util'
import store from '@/store'
import router from '@/router'
import i18n from '@/lang'

const $message = Message
let globalMessage = ''

export function createApiRequest(config) {
    return function apiRequest(data?: any, otherAjaxOptions?: any, filterResolveDate?: Function, showError = true, qsFormat = false) {
        let options = util.cloneDeep(config)
        if (typeof config === 'string') {
            options = {
                url: config,
            }
        }
        data = util.cloneDeep(data)
        if (otherAjaxOptions) {
            Object.assign(options, otherAjaxOptions)
        }
        options.url = options.url.replace(/\{(.+?)\}/g, (match, key) => { // 修改url中"{}"包含的参数
            const val = data[key]
            delete data[key]
            return val
        })
        let { format } = options
        if (format && format.request != null && data) {    // 按照规定类型格式化所传json
            let formatData = { data }
            util.formatParamsType(formatData, 'data', format.request)
            data = formatData.data
        }
        if (data) {
            options[options.method === 'GET' ? 'params' : 'data'] = data
        }

        options.headers = options.headers || {}
        if (!options.headers.TimeZone) {
            options.headers.TimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        }
        const scheduleLock = (store as any).state.scheduleTaskEditLock
        if (scheduleLock && typeof scheduleLock === 'string') {
            options.headers.scheduleTaskEditLock = scheduleLock
        } else {
            delete options.headers.scheduleTaskEditLock
        }
        const searchParams = new URLSearchParams(window.location.search)
        const userCompanyInfo = JSON.parse(localStorage.getItem('userCompanyInfo') || '{}')
        if (Object.keys(userCompanyInfo).length) {
            if (userCompanyInfo.companyList && userCompanyInfo.companyList.length > 0) {
                options.headers.companyIdSelected = userCompanyInfo.id || -1
            }
        }
        if (Object.keys(userCompanyInfo).length) {
            options.headers.companyIdSelected = userCompanyInfo.id || -1
        } else if (searchParams.get('companyIdSelected')) {
            options.headers.companyIdSelected = searchParams.get('companyIdSelected')
        }
        if ((!(otherAjaxOptions && otherAjaxOptions.noNeedLangCode))) {
            options.headers.langCode = 'en'
            if (!(window.location.pathname.includes('/setting/templates/detail/') // 模板编辑页面
                || window.location.pathname.includes('/contract/pdf/preview/') // 合同预览页面
                || window.location.pathname.includes('/contract/pdf/sign/') // 合同签字页面
                || window.location.pathname.includes('/contract/template/edit/')) // 合同内编辑模板页面
            ) {
                options.headers.langCode = (i18n.locale === 'zh-Hant' ? 'zh-HK' : i18n.locale) || 'en'
            }
        }

        if (router.app && router.app.$route.meta && router.app.$route.meta.position) {
            options.headers = options.headers || {}
            options.headers.PageName = router.app.$route.meta.position.call(router.app.$route)
            options.headers.PageUrl = window.location.href
        }
        if (store.getters.isAdminAndSelected) {
            options.headers['agency-id'] = (<any>store).state.adminSelectedCompany.id
        } else {
            delete options.headers['agency-id']
        }

        if (qsFormat) {
            options.paramsSerializer = params => qs.stringify(params, {arrayFormat: 'repeat'})
        }

        return sendApiRequest(options, filterResolveDate, showError)
    }
}

export function sendApiRequest(ops: any, filterResolveDate?: Function, showError = true): Promise<any> {
    return new Promise(((resolve, reject) => {
        axios.request(ops)
            .then(async response => {
                let {data} = response
                let responseType = Object.prototype.toString.call(response.data)
                if (responseType === '[object Blob]' || responseType === '[object ArrayBuffer]') {      // 如果responseType指定了blob或arraybuffer
                    try {
                        data = JSON.parse(<string>(await util.blobToString(new Blob([data])))) // 接口报错时返回json
                    } catch (e) {
                        return resolve(response)
                    }
                }
                data = data || {
                    code: null,
                    message: null,
                    data: null,
                }
                data.code = +data.code
                if (data.code === 20010013) {
                    router.push({ name: 'NotFound' })
                    return
                }

                if (data.code !== 200) {
                    data.message = data.code === 401 ? 'You have not logged in yet. Please re-login!' : (data.message || data.msg || 'Server Error')

                    // code 白名单
                    let whiteList = [20013003, 20013004, 20013005, 20013011, 20013012, 2009001, 20013014]
                    if (whiteList.includes(data.code)) return resolve(response)

                    if (data.code === 20060020) { // 锁过期
                        $message.error('Oops! the information has been changed during your operation.')
                        setTimeout(() => {
                            window.location.reload()
                        }, 500)
                        return
                    }

                    if (data.code === 20060023) {
                        MessageBox.alert('', data.message, {
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                            showClose: false,
                            confirmButtonText: 'Refresh',
                            callback: () => {
                                window.location.reload()
                            },
                        })
                        return
                    }

                    if (data.code === 10010001) {
                        data.message = 'Password is incorrect.'
                    }
                    if (data.code === 401) {
                        logout()
                    }
                    if (data.code === 20010010) {
                        globalMessage = data.message || data.msg
                    }
                    if (!globalMessage) {
                        if ([20040007, 20070005, 2009008, 20080002, 20070028].includes(data.code)) {
                            reject(data)
                        } else {
                            if (showError) {
                                $message.error(data.message || data.msg || 'Server Error')
                            }
                            reject(data)
                        }
                    }
                    if (globalMessage) {
                        store.commit('SET_IS_DISABLED', true)
                    }
                } else {
                    data.originData = data.data
                    if (ops.format && ops.format.response != null) {    // 给返回值设置默认值
                        util.setDefaultData(data, 'data', util.cloneDeep(ops.format.response))
                    }
                    if (typeof filterResolveDate === 'function') {
                        data = filterResolveDate(data)
                    }
                    resolve(data)
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    logout()
                }
                if (showError) {
                    $message.error(error.message || 'Server Error')
                }
                reject(error)
            })
    }))
}

function logout() {
    store.dispatch('logout', {isRequiredLog: true})
}
